import { IUpdateSettings } from "@/api/AppApi/services/auth/interfaces/IAuth";
import { FieldTypes } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { DeliveryMethodsTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { IKeyValue } from "@/api/AppApi/services/filters/interfaces/IGetFilters";
import { AddressTypes } from "@/app/components/common-form-builder/common-fields/hook-address-type/address-type-btn/AddressTypeButton";
import { IReceivingSettingsStorage } from "@/hooks/receivingHeaderAtom";
import moment from "moment";

export enum RecievingFields {
  recievingFieldName = "receiving_type",
  branchFieldName = "pickup_branch",
  addressIdFieldName = "delivery_address",
  preferredBranchFieldName = "delivery_branch",
  deliveryTimeTypeFieldName = "delivery_time_type",
  pickupTimeTypeFieldName = "pickup_time_type",
  deliveryTimeFieldName = "deliveryTime",
  pickupTimeFieldName = "pickup_time",
  addressNameField = "address(address_name",
  counteryField = "address(country_id",
  cityField = "address(city_id",
  areaField = "address(area_id",
}

export const recievingFieldsDefultValues = (
  settings: IUpdateSettings,
  delivery_methods: DeliveryMethodsTypes[],
) => {
  return {
    [RecievingFields.pickupTimeFieldName]: {
      type: FieldTypes.date_time,
      value: settings?.pickup_time
        ? moment(settings?.pickup_time).toDate()
        : null,
    },
    [RecievingFields.deliveryTimeFieldName]: {
      type: FieldTypes.date_time,
      value: settings?.delivery_time
        ? moment(settings?.delivery_time).toDate()
        : null,
    },
    [RecievingFields.branchFieldName]: settings?.pickup_branch,
    [RecievingFields.addressIdFieldName]: settings?.delivery_address,
    [RecievingFields.recievingFieldName]:
      settings?.receiving_type ?? delivery_methods[0],
    [RecievingFields.deliveryTimeTypeFieldName]:
      settings?.delivery_time_type ?? "now",
    [RecievingFields.pickupTimeTypeFieldName]:
      settings?.pickup_time_type ?? "now",
  };
};

type ReceivingData = {
  pickup_time: string | null;
  pickup_branch: number;
  receiving_type?: DeliveryMethodsTypes;
  delivery_time_type: "custom" | "now" | undefined;
  pickup_time_type: "custom" | "now";
  delivery_time: null | string;
  address: {
    country_id: IKeyValue;
    city_id: IKeyValue;
    area_id: IKeyValue;
    address_name: AddressTypes;
  };
  preferred_branch_id: number;
  delivery_address?: number | string;
  delivery_address_type: "address" | "current" | undefined;
};

export const datatoStore = (
  data: ReceivingData,
): IReceivingSettingsStorage => ({
  receiving_type: data?.receiving_type!,
  delivery_address_type: data?.delivery_address_type,
  delivery_address: data?.delivery_address,
  address: data?.address,
  delivery_time_type: data?.delivery_time_type,
  delivery_time: data?.delivery_time,
  pickup_time_type: data?.pickup_time_type,
  pickup_time: data?.pickup_time,
});

export const getSettingsFromStorage = (
  data: IReceivingSettingsStorage,
): IUpdateSettings =>
  ({
    ...data,
    delivery_address_obj: {
      address: "",
      address_name: data?.address?.address_name as AddressTypes,
      area_id: +data?.address?.area_id?.key!,
      area_name: data?.address?.area_id?.value!,
      city_id: +data?.address?.city_id?.key!,
      city_name: data?.address?.city_id?.value!,
      contact_name: "",
      country_id: +data?.address?.country_id?.key!,
      country_name: data?.address?.country_id?.value!,
      id: undefined,
      is_default: false,
      mobile: "",
      other_address: "",
      phone: null,
    },
    pickup_branch_obj: data?.receiving_branch!,
  } as unknown as IUpdateSettings);
